import { ToggleGroup, ToggleGroupItem } from "@design-lab/shared/ui/toggleGroup";
import { usePlacementPosition, useArtworkForm } from "@design-lab/entities/artwork";
import { trackPlacementChanged } from "@design-lab/shared/lib/analytics";
import type { PlacementFormPosition } from "@design-lab/shared/types";
import { useCurrentComposition } from "@design-lab/entities/composition";

export function ImagePlacement() {
  const { lens } = useArtworkForm();
  const currentPlacementLens = lens.focus("currentPlacement");
  const selectedFrontPlacementLens = lens.focus("selectedFrontPlacement");
  const currentPlacement = usePlacementPosition(currentPlacementLens);
  const selectedFrontPlacement = usePlacementPosition(selectedFrontPlacementLens);
  const { currentProduct } = useCurrentComposition();
  const { sides } = currentProduct?.surfaceMeta || {};

  const options =
    currentPlacement.placement === "back"
      ? [{ value: "back", label: "Back center", disabled: false }]
      : [
          {
            value: "front",
            label: "Front center",
            disabled: !sides?.front?.includes("front")
          },
          {
            value: "frontLeftChest",
            label: "Left chest",
            disabled: !sides?.front?.includes("front_left_chest")
          }
        ];

  const handlePlacementChange = (value: PlacementFormPosition) => {
    if (value) {
      const fromPlacement = currentPlacement.placement;
      const toPlacement = value;

      if (fromPlacement !== toPlacement) {
        trackPlacementChanged(fromPlacement, toPlacement);
      }

      if (value.startsWith("front")) {
        selectedFrontPlacement.setPlacement(value);
      }
      currentPlacement.setPlacement(value);
    }
  };

  return (
    <ToggleGroup
      variant="outline"
      type="single"
      size="lg"
      value={currentPlacement.placement}
      onValueChange={handlePlacementChange}
      className="justify-start lg:justify-center"
    >
      {options.map(option => (
        <ToggleGroupItem
          disabled={option.disabled}
          data-testid={`placement-${option.value}-toggle`}
          key={option.value}
          value={option.value as PlacementFormPosition}
        >
          {option.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
